import React, { useState, useEffect, memo, useMemo } from "react";
import { Chart } from "primereact/chart";
import { useTranslation } from 'react-i18next';
function ScansBarChart(props) {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
    

    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            fontColor: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500,
            },
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    };
    // console.log(props.data)
    setChartData(props?.metric_config || {});
    setChartOptions(options);
  }, [props.metric_config]);

  const memoizedBarchart = useMemo(
    () => <Chart type="bar" data={chartData} options={chartOptions} />,
    [
      JSON.stringify(chartData),
      chartOptions,
    ]
  );
  const {t}=useTranslation();
    const DRAG_AND_DROP=t("DRAG_AND_DROP")

  return (
    <>
      <div className="flex gap-3 align-items-center">
        {props.getDRDTooltip("drd-scan-bar", DRAG_AND_DROP)}
        {/* <ExportToCsv jsonData={props.excelData} filename={"BarChartData.csv"} /> */}
      </div>
      <label className="font-bold mb-2 flex justify-content-center">
        {t("HOURLY_SCANS")}
      </label>
      {memoizedBarchart}
    </>
  );
}

export default memo(ScansBarChart);
